// @ts-check
const colors = {
    green: '#7FC473',
    red: '#e36b6b',
    orange: '#FFA500',
    yellow: '#B88E0D',
};
window.addEventListener("load", () => {
    document.querySelectorAll(".wastl-js-target").forEach((traget) => {

        /*
            ? fetch data via ajax and init map
            ! if fetch fails use the data provided in the data attributes
        */

        fetch('?type=1116789&bezirk=' + traget.dataset.bezirk)
            .then((response) => {
                if (response.ok) return response.json();
                throw new Error("Network response was not ok.");
            })
            .then((res) => { init(traget.id, res.data, res.path); })
            .catch(() => init(traget.id, traget.dataset.xml, traget.dataset.path));
    });

    function init(id, data, localPath) {
        "use strict";

        const resp = new XMLParser().parse(data)?.root;
        if (!resp || resp.length == 0) throw new Error("Invalid XML response");

        const map = document.getElementById(id);
        if (!map) throw new Error(`Map with id ${id} not found`);

        if (map.getAttribute("data-bezirk") != "none") {
            renderStaticImageContent(resp, map, id, localPath);
        } else {
            renderSVGConten(resp, map, id);
        }

        /** @type {HTMLElement|null} */
        const placeholder = map.querySelector('.placeholder');
        placeholder?.style.setProperty("opacity", "0");
        setTimeout(() => placeholder?.remove(), 1000);

        /** @type {HTMLElement|null} */
        const spinner = map.querySelector(".loading-spinner");
        spinner?.style.setProperty("opacity", "0");
        setTimeout(() => spinner?.remove(), 1000);
    }

    function renderStaticImageContent(resp, map, id, localPath) {
        const image = map.querySelector(`img#${id}-image`);
        if (!image) throw new Error(`Image with id ${id}-image not found`);

        image.src = `${localPath}/${resp?.cOptionen?.cBackground.split("/").pop()}`;

        const dots = document.createElement("div");
        dots.classList.add("dots");
        map.appendChild(dots);

        for (const data of resp?.aFFNr) {
            const dot = document.createElement("div");
            dot.classList.add("dot");
            dot.id = data?.FFNr;
            dot.style.top = `${(data?.PixelOben / 424) * 100}%`;
            dot.style.left = `${(data?.PixelRechts / 500) * 100}%`;
            if (data?.Button) {
                dot.style.backgroundImage = `url(${localPath || resp?.cOptionen?.cButP}/${data?.Button})`;
            }
            dots.appendChild(dot);
        }

        const coords = {
            1000: { left: 217, top: 155 },
            1001: { left: 219, top: 209 },
            1002: { left: 327, top: 244 },
            1013: { left: 334, top: 197 },
            1003: { left: 374, top: 121 },
            1004: { left: 378, top: 228 },
            1005: { left: 296, top: 326 },
            1006: { left: 94, top: 226 },
            1007: { left: 321, top: 261 },
            1008: { left: 410, top: 257 },
            1015: { left: 171, top: 203 },
            1019: { left: 317, top: 310 },
            1020: { left: 144, top: 108 },
            1021: { left: 313, top: 213 },
            1023: { left: 291, top: 183 },
            1026: { left: 318, top: 182 },
            1027: { left: 163, top: 59 },
            1028: { left: 280, top: 169 },
            1010: { left: 117, top: 66 },
            1012: { left: 225, top: 96 },
            1011: { left: 296, top: 122 },
            1014: { left: 215, top: 252 },
        };

        const actives = document.getElementById("actives");

        for (const data of resp?.aBAZID) {
            if (data?.nLayer && data?.nLayer !== " ") {
                const img = document.createElement("img");
                img.src = `${localPath || resp?.cOptionen?.cLayP}/${data?.nLayer}`;
                actives.appendChild(img);
            }

            const dot = document.createElement("div");
            dot.classList.add("dot");
            dot.id = data?.nBAZID;
            if (data?.nBAZID && coords[data?.nBAZID]) {
                // Hintergrundbilder sind immer 500x424
                dot.style.top = `${(coords[data?.nBAZID].top / 424) * 100}%`;
                dot.style.left = `${(coords[data?.nBAZID].left / 500) * 100}%`;
            }
            if (data?.nBAZStatus) {
                dot.style.backgroundImage = `url(${localPath || resp?.cOptionen?.cButP}/${data?.nBAZStatus})`;
            }
            dots.appendChild(dot);
        }
    }

    function renderSVGConten(resp, map) {
        const svg = map.querySelector("svg");
        const mappingArray = [];

        function getHexColorFromFileName(name) {
            name = name.toLowerCase();

            switch (true) {
                case name.includes('grün'): return colors.green;
                case name.includes('rot'): return colors.red;
                case name.includes('orange'): return colors.orange;
                case name.includes('gelb'): return colors.yellow;
            }

            return false;
        }

        for (const data of resp?.aBAZID) {
            mappingArray.push({
                name: data.cFriendlyName,
                status: data.nBAZStatus,
                image: data.nLayer,
                id: data.nBAZID,
                incidents: data.CountEinsatz,
                stations: data.CountFeuerwehr,
                mappingData: {
                    svgContenName: data.cFriendlyName.replace('BAZ ', '').replace('AAZ ', '').trim(),
                    tooltipName: data.cFriendlyName.trim(),
                    fillColor: getHexColorFromFileName(data.nLayer),
                    fillColorName: data.nLayer,
                }
            });
        }

        const activeStationsList = map.parentElement.querySelector(".activeStations ul");
        let stationsInMission = false;
        mappingArray.forEach((data) => {
            const element = svg.querySelector('[inkscape\\:label="' + data.mappingData.svgContenName + '"]');
            if (!element) return;

            if(data.stations === 1) {
                const station = document.createElement('li');
                station.textContent = 'Im Bezirk ' + data.mappingData.svgContenName + ' ist eine Feuerwehr im Einsatz';
                activeStationsList.appendChild(station);
                stationsInMission = true;
            } else if(data.stations > 1) {
                const station = document.createElement('li');
                station.textContent = 'Im Bezirk ' + data.mappingData.svgContenName + ' sind ' + data.stations + ' Feuerwehren im Einsatz';
                activeStationsList.appendChild(station);
                stationsInMission = true;
            }


            element.addEventListener('mousemove', (evt) => {
                let tooltip = document.querySelector('#wastl-tooltip');
                if (!tooltip) {
                    tooltip = document.createElement('div');
                    tooltip.id = 'wastl-tooltip';
                    tooltip.setAttribute('role', 'tooltip');
                    document.body.appendChild(tooltip);
                }
                element.setAttribute('aria-describedby', 'wastl-tooltip');

                tooltip.innerHTML = /* HTML */`
                    <div class="t-heading">
                        <span>${data.mappingData.tooltipName}</span>
                    </div>
                    <div class="t-line">
                        <div>Feuerwehren im Einsatz:</div>
                        <div class="t-line-val">${data.stations}</div>
                    </div>
                `;

                tooltip.style.left = evt.pageX + 10 + 'px';
                tooltip.style.top = evt.pageY - 50 + 'px';
            });

            element.addEventListener('mouseout', () => {
                document.querySelector('#wastl-tooltip')?.remove();
                element.removeAttribute('aria-describedby');
            });


            const color = data.mappingData.fillColor;
            if (color) {
                let fill = color;

                switch (color) {
                    case colors.yellow: fill = "url(#striped-yellow)"; break;
                    case colors.red: fill = "url(#striped-red)"; break;
                    case colors.green: fill = color; break;
                }

                element.style.fill = fill;
                element.querySelectorAll('*').forEach((child) => {
                    child.style.fill = fill;
                });
            }
        });

        if(!stationsInMission) {
            const activeStations = map.parentElement.querySelector(".activeStations");
            // remove all content in activeStations
            activeStations.innerHTML = '';

            const text = document.createElement('h4');
            text.textContent = 'Es sind keine Feuerwehren im Einsatz!';
            activeStations.appendChild(text);
        }
    }
});